import React from 'react';
import {
  Section,
  SettingsBoxesWrapper,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
  SettingToggle,
} from '@views/Settings/components';
import useEnabledNotifications from '../Notifications/use-enabled-notifications';
import styles from './Home.module.scss';
import RequestMissingBirthdays from './RequestMissingBirthdays';
import Reconnect from './Reconnect';

export default function HomeSettingsPanel() {
  const { enabledNotifications, toggleNotification } = useEnabledNotifications();

  return (
    <Section>
      <SettingsSectionLabel>Customize Home Feed</SettingsSectionLabel>
      <SettingsBoxesWrapper>
        <SettingsSectionBox>
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="Birthdays"
              checked={enabledNotifications['activity_birthdays']}
              name="activity_birthdays"
              onChange={() => toggleNotification('activity_birthdays')}
            />
            <p>Get notified when someone you know is celebrating their birthday.</p>
          </SettingsSectionRow>
          <RequestMissingBirthdays />
        </SettingsSectionBox>
        <SettingsSectionBox>
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="Calendar Relationships"
              checked={enabledNotifications['activity_events']}
              name="activity_events"
              onChange={() => toggleNotification('activity_events')}
            />
            <p>This includes people you have calendar events with.</p>
          </SettingsSectionRow>
          {/* Gray out the below if above is disabled */}
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="Recurring Events"
              checked={enabledNotifications['include_recurring_events']}
              name="include_recurring_events"
              onChange={() => toggleNotification('include_recurring_events')}
            />
            <p>Includes people from recurring calendar events.</p>
          </SettingsSectionRow>
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="Recent People"
              checked={enabledNotifications['include_recent']}
              name="include_recent"
              onChange={() => toggleNotification('include_recent')}
            />
            <p>Include people you've met in the past 14 days.</p>
          </SettingsSectionRow>
        </SettingsSectionBox>
        <SettingsSectionBox>
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="News"
              checked={enabledNotifications['activity_news']}
              name="activity_news"
              onChange={() => toggleNotification('activity_news')}
            />
            <p>
              Get notified when someone you know is mentioned in one of over 20,000 global
              publications.
            </p>
          </SettingsSectionRow>
        </SettingsSectionBox>
        <SettingsSectionBox>
          <SettingsSectionRow className={styles.container}>
            <SettingToggle
              title="Reconnect"
              checked={enabledNotifications['activity_reconnects']}
              name="activity_reconnects"
              onChange={() => toggleNotification('activity_reconnects')}
            />
            <p>Get reminders to reconnect with people you haven't talked to recently.</p>
          </SettingsSectionRow>
          <Reconnect disabled={!enabledNotifications['activity_reconnects']} />
        </SettingsSectionBox>
      </SettingsBoxesWrapper>
    </Section>
  );
}
